export interface CustomPointOfInterest {
  source?: string;
  locationId: number;
  organisationId: string;
  name: string;
  code: string;
  locationTypeId: number;
  latitude: number;
  longitude: number;
  distance?: number;
  createdAt: number;
}

export interface Airport {
  source: string;
  locationId: number;
  name: string | undefined;
  ICAO: string | undefined;
  IATA: string | undefined;
  other: string | undefined;
  locationTypeId: number;
  latitude: number;
  longitude: number;
  distance: number;
}

export type PointOfInterest = CustomPointOfInterest | Airport;

export interface LocationType {
  id: number;
  airportType: string;
  description: string;
  abbreviation: string;
  rotaryWing: boolean;
  fixedWing: boolean;
}

export enum PoiCodePreference {
  IATA = 'IATA',
  ICAO = 'ICAO'
}

export enum PoiCreateMinimumRole {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER'
}

export const DEFAULT_POI_CODE_PREFERENCE = PoiCodePreference.IATA;

export interface CreateCustomPoiResponseType {
  id: number;
  locationId: number;
  organisationId: string;
  code: string;
  name: string;
}
